export default {
	getAll() {
		return [
			{ id: '0', name: 'None' },
			{ id: '1', name: 'Weekly' },
			{ id: '2', name: 'Monthly' }
		];
	},
};
